<template>
  <div v-html="contents" class="alert alert-danger"></div>
</template>

<script>
export default {
  name: 'Info',

  props: {
    contents: {
      required: true,
      type: String
    }
  }
}
</script>
